/** Kurze PIN für Mitarbeitende am Kiosk: 6 Ziffern, keine trivialen Folgen. */
export function checkPin(pin: string): "pin_format" | "pin_trivial" | null {
  if (!/^\d{6}$/.test(pin)) return "pin_format";
  const d = [...pin].map(Number);
  const allSame = d.every((x) => x === d[0]);
  const asc = d.every((x, i) => i === 0 || x === (d[i - 1]! + 1) % 10);
  const desc = d.every((x, i) => i === 0 || x === (d[i - 1]! + 9) % 10);
  const repeatPair = pin === pin.slice(0, 2).repeat(3) || pin === pin.slice(0, 3).repeat(2);
  if (
    allSame ||
    asc ||
    desc ||
    repeatPair ||
    ["123123", "112233", "121212", "696969", "159753"].includes(pin)
  )
    return "pin_trivial";
  return null;
}
